/* eslint-disable require-jsdoc */
export default function timeStamp() {
  return new Date().toISOString();
}
